/** An envelope kind's chip tint (visual contract v2 §8): Cash sky, Budget peach, Goal sage. */
import type { EnvelopeKind } from '@/api/envelopes';
import type { TintName } from '@/theme/categorical';

export const ENVELOPE_KIND_TINT: Record<EnvelopeKind, TintName> = {
  CASH: 'sky',
  BUDGET: 'peach',
  SAVINGS: 'sage',
};
